import ExtenalCart from './ExternalCart';

export default ExtenalCart;


// WEBPACK FOOTER //
// ./src/pages/ExternalCart/index.tsx